export default "__VITE_ASSET__9YGXuogd__"